<template>
  <PrintTemplate
    :viewExtraFooter="false"
    :viewHeader="false"
    :viewFooter="false"
    orientation="landscape"
  >
    <table class="table table-bordered">
      <tr>
        <td colspan="4" class="text-center">
          <span class="float-left">1.</span>
          <b>Approving Competent Authority/Country</b> <br />
          <span style="margin-top: 5px; display: block; font-size: 16px">
            <b>EASA</b>
          </span>
        </td>
        <td colspan="5" class="text-center">
          <span class="float-left">2.</span>
          <b>AUTHORISED RELEASE CERTIFICATE <br>EASA FORM 1</b> <br />
        </td>

        <td colspan="3" class="text-center">
          <span class="float-left">3.</span>Form Tracking Number <br />
          <span style="margin-top: 5px; display: block; font-size: 16px">
            {{ formModel.form_one ? formModel.form_one.form_one_id : "" }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="9">
          <div style="display: flex; justify-content: space-between;">
            <div class="mr-2 ">
              <span class="float-left">4. Organisation Name and Address:</span>
              <br />
              <div class="ml-2">
                <img height="50px" src="/images/form1-header.png" alt="" />
              </div>
            </div>
            <p
              class="mr-2 mt-0"
              style="font-weight: bold; cursor: pointer; margin-bottom: 0px"
              @click="openAddressWindow"
              v-html="renderAddress"
            ></p>
          </div>
        </td>
        <td colspan="3" class="text-center">
          <span class="float-left">5.</span> Work Order/Contract/Invoice:
          <br />
          <span style="margin-top: 10px; display: block; font-size: 16px">
            {{ formModel.jo_no }}
          </span>
        </td>
      </tr>
      <tr>
        <td colspan="1">6. Item</td>
        <td colspan="3">7. Description</td>
        <td colspan="2">8. Part No.</td>
        <td colspan="1">9. Qty</td>
        <td colspan="2">10. Serial No.</td>
        <td colspan="3">11. Status/Work</td>
      </tr>
      <tr>
        <td
          colspan="1"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          1
        </td>
        <td
          colspan="3"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.description }}
        </td>
        <td
          colspan="2"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.jo_part }}
        </td>
        <td
          colspan="1"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          1
        </td>
        <td
          colspan="2"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          {{ masterlist.uld_id_code }}
        </td>
        <td
          colspan="3"
          class="text-center"
          style="padding-top: 10px; padding-bottom: 10px"
        >
          Repaired
        </td>
      </tr>
      <tr>
        <td colspan="12">
          <span style="position: absolute; float: left">
            12. Remarks:
            <a href="#" @click.stop="openWindow"
              ><span class="el-icon-edit h-print"></span>
            </a>
          </span>
          <div class="text-center">
            {{ remarks }}
          </div>
          <div class="text-center" style="">
            {{ masterlist.cmm.rev_desc }}
          </div>
          <i
            ><small style="font-size: smaller"
              >*refer to Job Order for repair details.</small
            >
          </i>
        </td>
      </tr>
      <tr>
        <td id="td-1" style="width: 50%; background: #CCC; " colspan="6">
          <div style="position: relative">
            <svg
              height="100%"
              width="100%"
              style="position: absolute; left: -8px; top: -8px; overflow: visible; pointer-events: none;"
            >
              <line
                x1="0"
                y1="0"
                :x2="line().x"
                :y2="line().y"
                style="stroke: #000; stroke-width: 1"
              ></line>
            </svg>
            <svg
              height="100%"
              width="100%"
              style="position: absolute; left: -8px; top: -8px; overflow: visible; pointer-events: none;"
            >
              <line
                x2="0"
                y1="0"
                :x1="line().x"
                :y2="line().y"
                style="stroke: #000; stroke-width: 1"
              ></line>
            </svg>
            <span
              >13a. Certifies that the items identified above were manufactured
              in conformity to:</span
            >
            <div class="form-item mt-1">
              <!-- <input type="checkbox" id="cbx_13a" class="form-control" /> -->
              <span class="xbox"></span>
              <label for="cbx_13a"
                >approved design data and are in condition for safe
                operation</label
              >
            </div>
            <div class="form-item">
              <!-- <input type="checkbox" id="cbx_13b" class="form-control" /> -->
              <span class="xbox"></span>
              <label for="cbx_13b"
                >non-approved design data specified in block 12</label
              >
            </div>
          </div>
        </td>
        <td style="width: 50%" colspan="6">
          <div class="form-item mb-1">
            <span>14a.</span>
            <span class="xbox">
              <span class="el-icon-close"></span>
            </span>
            <!-- <input type="checkbox" id="cbx_13a" class="form-control" /> -->
            <label for="cbx_14a"><u>Part 145.A.50</u> Release to Service </label>
            <!-- <input type="checkbox" id="cbx_13a" class="form-control ml-1" /> -->
            <span class="xbox"></span>
            <label for="cbx_14a">Other regulation specified in block 12</label>
          </div>
          <p style="font-size: 14px; margin-bottom: 0; ">
            Certifies that unless otherwise specified in block 12, the work identified in 
            block 11 and described in block 12, was accomplished in accordance with <u>Part 145</u>
            and in respect to that work the items are considered ready for release to service
          </p>
        </td>
      </tr>
      <tr>
        <td id="td-2" colspan="3" style="background: #CCC; width: 25%">
          <span>13b. Authorised Signature</span>
        </td>
        <td id="td-3" colspan="3" style="background: #CCC; width: 25%">
          <span>13c. Approval/Authorisation Number</span>
        </td>
        <td colspan="3" style="width: 25%">
          <span>14b. Authorised Signature</span> <br />
          <div style="position: relative">
            <img
              style="height: 50px; position: absolute; left: 0; right: 0; margin: auto; mix-blend-mode: multiply"
              v-if="formModel.supervisor.sign"
              :src="getPath(formModel.supervisor.sign)"
            />
          </div>
        </td>
        <td colspan="3" style="width: 25%">
          <span>14c. Certificate/Approved Ref. No.</span> <br />
          <div class="text-center mt-1">
            <b>EASA.145.0928</b>
          </div>
        </td>
      </tr>
      <tr>
        <td id="td-4" style="background: #CCC" colspan="3">
          <span>13d. Name</span>
        </td>
        <td id="td-5" style="background: #CCC" colspan="3">
          <span>13e. Date (dd mmm yyyy)</span>
        </td>
        <td colspan="3">
          <span>14d. Name</span>
          <div class="text-center mt-1">
            {{ formModel.supervisor.fullname }}
          </div>
        </td>
        <td colspan="3">
          <span>14e. Date (dd mmm yyyy)</span>
          <div class="text-center mt-1">
            {{ formModel.date_job_completed }}
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="12">
          <b>USER/INSTALLER RESPONSIBILITIES </b>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 4px">
            This certificate does not automatically constitute authority to install the item(s).
          </p>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 4px">
            Where the user/installer performs work in accordance with the regulations of an airworthiness authority different 
            than the airworthiness authority specified in block 1, 
            it is essential that the user/installer ensures that his/her airworthiness 
            authority accepts items from the airworthiness authority specified in block 1.
          </p>
          <p style="font-size: 14px; margin-top: 0; margin-bottom: 0">
            Statements in blocks 13a and 14a do not constitute installation certification. 
            In all cases the aircraft maintenance records must contain an installation certification 
            issued in accordance with the national regulations by the user/installer before the aircraft 
            may be flown.
          </p>
        </td>
      </tr>
    </table>
    <span style="font-size: 10px; margin-top: 0; margin-bottom: 4px">EASA Form 1 - MF/CAO/145 Issue 3</span>
    <el-dialog
      :visible.sync="windowState"
      min-width="250px"
      title="Input remarks"
    >
    <el-input
      type="textarea"
      :rows="3"
      placeholder="Remarks here"
      label-position="top"
      v-model="remarks">
    </el-input>
      <!-- <el-form :model="remark" label-position="top">
        <el-form-item>
          <el-select v-model="remark.id">
            <el-option
              v-for="item in remarkList"
              :key="item.id"
              :value="item.id"
              :label="item.text"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form> -->
    </el-dialog>
    <el-dialog
      :visible.sync="addressWindowState"
      min-width="250px"
      title="Edit Address"
    >
      <el-form>
        <el-form-item>
          <el-input type="textarea" :rows="5" v-model="address"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </PrintTemplate>
</template>

<script>
import PrintTemplate from "@/components/PrintTemplateLandscape.vue";
import ULD from "@/models/ULD";
import Masterlist from "@/models/Masterlist";
import moment from "moment";
export default {
  name: "Form1A",
  components: { PrintTemplate },
  data: () => ({
    formModel: new ULD({ supervisor: {}, mechanic: {} }),
    isLoading: false,
    customers: [],
    masterlist: { cmm: {} },
    windowState: false,
    remarks: 'This Unit Load Device (ULD) was repaired in accordance with below OEM’s Component Maintenance Manual:',
    addressWindowState: false,
    address:
      "Warehouse No. B1501-1502, Blue Lake Properties Compound \nICAD 3, Mussafah Industrial Area, P.O. Box 91219 \nAbu Dhabi, United Arab Emirates \nTel. No.: +971 2 5509485 E-mail: uld_repair@totalx.ae",
    remarkList: [
      {
        id: 0,
        text:
          "This Unit Load Device (ULD) was repaired in accordance with below OEM’s Component Maintenance Manual:"
      },
      {
        id: 1,
        text:
          "This Pallet Net was repaired in accordance with below OEM’s Component Maintenance Manual:"
      },
      {
        id: 2,
        text:
          "This Galley Cart was repaired in accordance with below OEM’s Component Maintenance Manual:"
      }
    ]
  }),
  computed: {
    trackingNo() {
      return "TXRC.20.0001";
    },
    // remarks() {
    //   return this.remarkList.find(o => o.id == this.remark.id);
    // },
    currdate() {
      let str = moment()
        .format("DD MMM YYYY")
        .toLowerCase();
      return str;
    },
    renderAddress() {
      return this.address.replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
  },
  methods: {
    getPath(data) {
      return "data:image/jpg;base64," + data;
    },
    openWindow() {
      this.windowState = true;
    },
    line() {
      let c = { x: 0, y: 0 };
      let td1 = document.getElementById("td-1");
      let td2 = document.getElementById("td-2");
      // let td4 = document.getElementById("td-4");
      let td5 = document.getElementById("td-5");
      if (td1) {
        c.y =
          td1.getBoundingClientRect().height +
          td2.getBoundingClientRect().height +
          td5.getBoundingClientRect().height;
        c.x = td1.getBoundingClientRect().width;
      }
      return c;
    },
    openAddressWindow() {
      this.addressWindowState = true;
    }
  },
  mounted() {
    this.customers = [];
    ULD.customers_data().then(list => {
      this.customers = list;
    });

    let id = this.$route.params.id;
    if (id) {
      this.isLoading = true;
      ULD.list({ id: id }).then(data => {
        this.isLoading = false;

        let item = data.data[0];

        this.formModel = new ULD({
          id: item.id,
          jo_no: "TXJO-" + item.id.toString().padStart(5, 0),
          // code_id: item.code.id,
          location_id: item.location.id,
          masterlist_id: item.masterlist.id,
          status_id: item.status.id,
          type: item.type,
          description: item.description,
          date_received: item.date_received,
          job_completed: item.job_completed,
          // (formModel.job_completed | dateFormat("D MMM YYYY")).toLowerCase()
          date_job_completed: moment(item.job_completed)
            .format("D MMM YYYY")
            .toLowerCase(),
          mechanic: item.mechanic,
          supervisor: item.supervisor,
          labor: item.labor,
          locked: item.locked ? true : false,
          materials: item.materials,
          damages: item.damages,
          customer: item.customer,
          // total_repaired_time: repairTime,
          customer_desc: this.customers.find(o => {
            return o.value == item.customer;
          }),
          form_one: item.form_one ? item.form_one : {}
        });
        Masterlist.list({ id: item.masterlist.id }).then(resp => {
          this.masterlist = resp.data[0];
        });
        let date = moment().format("YYYY-MM-DD");
        document.title = "TX Repair Software - ULD Form 1A " + date;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-size: 14px;
}
table {
  table-layout: fixed;
}
.table-bordered {
  th,
  td {
    border: 1px solid #333;
    padding-top: 8px;
    padding-bottom: 8px;
    vertical-align: top;
  }
}
.float-left {
  float: left;
}
.form-item {
  display: flex;
  align-items: center;
  input.form-control[type="checkbox"] {
    width: 15px;
    margin-right: 8px;
  }
}
.xbox {
  position: relative;
  display: inline;
  margin-left: 8px;
  margin-right: 8px;
  border: 1px solid #888;
  border-radius: 4px;
  color: #000;
  height: 13px;
  width: 14px;
  font-weight: bold;
  background-color: #fff;
  span {
    position: absolute;
    left: -2px;
    top: -2px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
